import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'space-between',
    padding: theme.spacing(1),
  },
  formContainer: {
    margin: theme.spacing(5),
    paddingRight: theme.spacing(12),
    display: 'flex',
    width: '100%',
  },
}));
